import type { SearchFiltersByName } from 'modules/search/types/FiltersByName/SearchFiltersByName';

import { algoliaQueryStringArrayFilter } from './algoliaQueryStringArrayFilter';
import { algoliaQueryStringFilter } from './algoliaQueryStringFilter';

export function algoliaBuildFilterString(filters: SearchFiltersByName): string {
  const validFilters = Object.entries(filters).filter(([_, value]) =>
    Array.isArray(value) ? value.length > 0 : !['', undefined].includes(value),
  );

  const filterStrings = validFilters.map(([facet, value]) => {
    if (Array.isArray(value)) {
      return algoliaQueryStringArrayFilter(facet, value);
    }
    return algoliaQueryStringFilter(facet, value);
  });

  return filterStrings.join(' AND ');
}
